export default __webpack_public_path__ + "static/media/32.16285f25.webp";